module.exports = __webpack_public_path__ + "static/assets/3e6a0a68ee1872bee1f93e4428bcb993.svg";